<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <!-- <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>
          <el-button type="primary" v-if="tableAcl.indexOf('ToPlan') != -1" class="btn primary" v-preventReClick :disabled="multiple" @click="toPlan">生成备货计划</el-button> -->

          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <!-- <div class="search">
            <input type="text" v-model="query.keyWord"  />
            <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i>
          </div>
          <span v-preventReClick @click="reset">重置</span> -->
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
          <template slot="before">
            <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
            </el-table-column>
          </template>
          <template slot="after">
          </template>
        </CustomTable>
      </div>
     <div v-else>
      <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
      style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
      <template slot="empty">
        <div class="empty-div" :style="{ height: tableHeight + 'px' }">
          <img src="../../../../assets/noData.png" width="240" height="240" />
          <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
          <div class="empty-rest" @click="reset">恢复默认</div>
        </div>
      </template>
      <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
      </el-table-column>
      <el-table-column prop="productNo" width="150" label="产品编码" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="productName" width="150" label="产品名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="specName" width="150" label="规格/型号" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="oldHisProjectNo" width="150" label="旧计费项目编号"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="oldHisProjectName" width="150" label="旧计费项目名称"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="newHisProjectNo" width="150" label="新计费项目编号"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="newHisProjectName" width="150" label="新计费项目名称"
        :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createdUserName" label="对码人" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="createdDeptName" label="所属科室" :show-overflow-tooltip="true"></el-table-column>

      <el-table-column prop="createdTime" min-width="170" label="对码时间">
        <template slot-scope="scope">
          {{ parseTime(new Date(scope.row.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }}
        </template>
      </el-table-column>
    </el-table>
    </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import { GetCompareCodeLogs } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
// import { PlanStateOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetCompareCodeLogs,
      // RemoveAction: RemoveStockUpApply,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: 'stock-up-apply-edit',

      // PlanStateOptions: PlanStateOptions,
      filterOptions: [
        {
          name: "产品",
          type: "select",
          code: "productId",
          filterMethod: this.getProductsNoDebounce,
          data: [],
        },
        {
          name: "对码人",
          type: "select",
          code: "createdUser",
          filterMethod: this.getUsers,
          data: [],
        },
        {
          name: "所属科室",
          type: "select",
          code: "createdDept",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],
    };
  },
  methods: {},
  mounted () { },
};
</script>

<style lang="scss" scoped></style>
